import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import './Stories.css'
import { deleteStories, loadStories } from '../../Redux/Actions/ActionStories';
import sto from '../../images/history.png'
import SinglePagenation from '../General/Pagination/SinglePagenation';
import { useNavigate } from 'react-router-dom';
import AddStory from './AddStory';
import ReactLoading from 'react-loading';

function Stories() {
    let role = localStorage.getItem('roleA');
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const [pageNumber, setPageNumber] = useState(0);
    let langLocal = localStorage.getItem('absherLang');
    const [t, i18n] = useTranslation();
    const [open, setOpen] = useState(false)
    const allStories = useSelector(state => state.stories.allStories)
    const loadingallStories = useSelector(state => state.stories.loadingallStories)
    useEffect(() => {
        dispatch(loadStories());
    }, [])
    const handleDelete = (id) => {
        dispatch(deleteStories(id))
    }
    const stroiesPerPage = 12;
    const pagesVisited = pageNumber * stroiesPerPage;
    const displaystories = allStories.slice(
        pagesVisited,
        pagesVisited + stroiesPerPage
    );

    const pageCount = Math.ceil(allStories.length / stroiesPerPage);
    const changePage = ({ selected }) => {
        setPageNumber(selected);
    };
    const toStoryDetails = (id) => {
        navigate(`/stories/${id}`)
    }
    return (
        <>
            <main>
                <div className="page_header" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    <h2>{t('stories')}</h2>
                    {
                        role !== '2' && (
                            <button onClick={() => setOpen(true)} >
                                <i className="fa fa-plus" ></i>
                                <span>{t('addstory')}</span>
                            </button>
                        )
                    }
                </div>
                <div className='allstory' dir={langLocal == "ar" ? "rtl" : "ltr"} >
                    {
                        loadingallStories == false ? (
                            displaystories.map((aa) => {
                                return (
                                    <div className='onestory' >
                                        <img src={sto} />
                                        <br></br>
                                        {
                                            aa.vendor !== null && (
                                                <h3>{aa.vendor.name}</h3>
                                            )
                                        }
                                        <br></br>
                                        <p>has a <span className='num_story' >{aa.story_details_count}</span> stories</p>
                                        <div className='btn_story' >
                                            <button onClick={() => toStoryDetails(aa.id)} >View All Stories</button>
                                            {
                                                role !== '2' ? (
                                                    <i className='fa fa-trash' onClick={() => handleDelete(aa.id)} ></i>

                                                ) : ''
                                            }
                                        </div>
                                    </div>
                                )
                            })) : <div className="div_loading_normal" ><ReactLoading type="spinningBubbles" color="#36ADB0" height={'7%'} width={'7%'} /></div>
                    }
                </div>
                <SinglePagenation pageCount={pageCount} changePage={changePage} />
            </main>
            {
                open == true ? (
                    <AddStory open={open} setOpen={setOpen} />
                ) : <></>
            }
        </>
    )
}

export default Stories
